import { useTranslation } from "react-i18next";

import ActionPanelFrame, { ReturnActionPanelProps } from "./ActionPanelFrame";

/** Tell eBay the item is back without checking it. Received and checked on the return page normally does this. */
export default function MarkReceivedPanel({ detail, onConfirm, onCancel, busy }: ReturnActionPanelProps) {
  const { t } = useTranslation("returns");
  return (
    <ActionPanelFrame kind="mark_received" detail={detail} messageRequired={false} onConfirm={(message) => onConfirm({ message })} onCancel={onCancel} busy={busy}>
      <div className="rounded-lg border border-amber-200 bg-amber-50 px-3 py-2.5 text-[12px] text-amber-900">
        {t("Marking it received starts eBay's 2-business-day refund clock. Fill in Received and checked on this page too, so the condition is on record before you refund.")}
      </div>
    </ActionPanelFrame>
  );
}
